function initialState () {
  return {
    sidebar: {
      closed: false
    },
    device: 'desktop',
    size: 'medium'
  }
}

export default {
  namespaced: true,

  state: initialState,

  mutations: {
    toggleSidebar (state, sidebar) {
      state.sidebar.closed = sidebar
    }
  },

  actions: {
    toggleSidebar ({ commit }, sidebar) {
      commit('toggleSidebar', sidebar)
    }
  },

  getters: {
    toggleSidebar (state) {
      return state.sidebar
    }
  }
}
